import {call, put, takeEvery} from "redux-saga/effects";
import DealerService from "../services/api/DealerService";
import * as types from "../constants/ActionTypes";
import * as actions from "../actions/dealersActions";

function* fetchDealers() {
    try {
        const dealers = yield call(DealerService.getDealers);
        yield put(actions.fetchDealersSuccess(dealers.body));
    } catch (error) {
        yield put(actions.fetchDealersFailure(error));
    }
}

export function* watchDealers() {
    yield takeEvery(types.FETCH_DEALERS, fetchDealers);
}
